<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <section class="md:container px-5 lg:px-0 md:px-0">
    <div class="flex flex-col lg:flex-row items-center content-between gap-[40px] lg:gap-20">
      <div class="w-full lg:w-3/5">
        <!-- Blog Title -->
        <div class="block mb-[11px] md:mb-[21px]">
          <h1 class="font-cocogoose text-[30px]">
            {{ title }}
          </h1>
        </div>
        <!-- ./Blog Title -->

        <!-- Section Description -->
        <p
          v-if="description && description.length"
          class="text-[#444444] text-[18px] leading-[36px]"
          v-html="description"
        />
        <!-- ./Section Description -->
      </div>

      <!-- Search Input -->
      <div class="w-full lg:w-2/5">
        <div class="flex relative w-full">
          <!-- Input -->
          <input
            type="text"
            class="search-article-input border w-full h-[50px] rounded-[6px] border-[#e5e7eb] px-5 outline-none focus:ring-1 focus:ring-blue-600 duration-200"
            :placeholder="$i18n('blog.search-article')"
            :value="searchValue"
            @keyup.enter="onSearch"
            @input="onInput"
          />
          <!-- ./Input -->

          <!-- Search Button -->
          <button
            class="duration-200 h-full absolute top-0 right-0 px-3.5 text-sm font-medium text-white bg-blue-600 rounded-r-[6px] border border-blue-600 hover:bg-blue-700 outline-none"
            :aria-label="$i18n('general.search')"
            @click="onSearch"
          >
            <!-- Search Icon -->
            <svg
              aria-hidden="true"
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            <!-- ./Search Icon -->
          </button>
          <!-- ./Search Button -->
        </div>
      </div>
      <!-- ./Search Input -->
    </div>
  </section>
</template>
<script>
export default {
  name: 'Search',
  props: {
    title: {
      type: String,
      default: 'Our Blog',
    },
    description: {
      type: String,
      default: null,
    },
    searchValue: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      searchText: null,
    };
  },
  methods: {
    onInput(e) {
      this.searchText = e?.target?.value;
    },
    onSearch() {
      const value = this.searchText && this.searchText.length ? this.searchText.trim() : null;
      this.$emit('search', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-article-input {
  box-shadow:
    0 6px 10px 0 rgba(3, 4, 8, 0.04),
    0 1px 2px 0 rgba(13, 16, 22, 0.06);
}
</style>
